import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import { QueryTypes } from "./shared";
import AlertDTO from "src/models/AlertDTO";
import EventDTO from "src/models/EventDTO";

export const useGetPremierPlusAlertsQuery = (binId: number | null, from: string | null | undefined, to: string | null | undefined, options: QueryTypes = {}) => {
    const getPremierPlusAlertsQueryKey = "getPremierPlusAlertsQuery";

    const getPremierPlusAlertsQuery = useQuery<EventDTO[]>({
        queryKey: [getPremierPlusAlertsQueryKey, binId, from, to],
        queryFn: async (q) => {
            if(binId == null){
                return [];
            }
            return await BinApiService.getPremierPlusEvents(binId, from, to, q.signal);
        },
        enabled: binId != null && options.enabled,
        refetchOnWindowFocus: options.refetchOnWindowFocus,
        retry: options.retry,
    })

    return { getPremierPlusAlertsQueryKey, getPremierPlusAlertsQuery };

}